import { t } from "@lingui/core/macro"
import { dom } from "../../../common/tsxrender/dom"
import { PromoteLinkBase } from "./promoteLinkBase"

export class PromoteRoomLink extends PromoteLinkBase {
    protected createElement(): HTMLAnchorElement {
        return <a bind={{ className: () => `panelLink promoteRoomLink ${this.state.isActive ? "" : "disabled"}` }}
            data-testid="promote-room-link"
            onClick={() => {this.clickHandler()}}
        >
            {t`Promote This Room`}
        </a>
    }
}
